module.exports = __webpack_public_path__ + "img/logo.331a6a29.png";